const Boxes = {
  box0: function(){
    var brd4 = JXG.JSXGraph.initBoard('jxgbox4',{boundingbox: [-10, 10, 10, -3],
        keepaspectratio: true, axis:false, ticks:{visible:false},
        grid:true, showCopyright:false, showNavigation:false,
        pan:{enabled:false}, zoom:{enabled:false}});

    brd4.suspendUpdate();

    brd4.options.layer['image'] =14;
    brd4.create('text', [-3, 9, '<b> Right Angled Triangle <b>'],{CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(28*brd4.canvasWidth/500.)}},);
    brd4.create('text', [-1.5 , 7.5, 'Hover '],{CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(18*brd4.canvasWidth/500.)}},);

    //Order
    //brd4.options.layer['imcrane'] =1;
    //brd4.options.layer['seesaw'] =2;

    //Variables
    var lineAc = brd4.create('segment', [[-6,0], [-6,1]], {visible: false});
    var lineOb = brd4.create('segment', [[-4,-1], [0,-1]], {visible: false});
    var lineAc2 = brd4.create('segment', [[1,-1], [5,-1]], {visible: false});

    var pAcute3 = brd4.create('glider', [-6, 4, lineAc],{fixed: false,visible: true, name:'C', size:2,  strokeColor:'black', snapToGrid:true,label: {offset: [-3,20], fontSize:function(){return 18*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});
    var pAcute1 = brd4.create('point', [-9, -1],{fixed: false, name:'A', size:0, strokeColor:'black', fillColor: 'red', snapToGrid:false, label: {offset: [-15,10], fontSize:function(){return 18*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});
    var pAcute2 = brd4.create('glider', [-4, -1 , lineOb],{fixed: false, name:'B', size:2, strokeColor:'black', snapToGrid:true,label: {fontSize:function(){return 18*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});

    var lineObtuse = brd4.create('segment', [[1,2], [1,10]], {visible: false});
    var pObtuse1 = brd4.create('point', [-1,-1],{fixed: true, name:'A', size:0, strokeColor:'black', fillColor: 'red', snapToGrid:false, label: {offset: [-15,10], fontSize:function(){return 18*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});
    var pObtuse2 = brd4.create('glider', [3,-1, lineAc2],{name:'B', size:2, strokeColor:'black', snapToGrid:true,label: {fontSize:function(){return 18*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});
    var pObtuse3 = brd4.create('glider', [1, 4, lineObtuse],{visible: true, name:'C', size:2,  strokeColor:'black', snapToGrid:true,label: {offset: [-3,20], fontSize:function(){return 18*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});

    var lineRight = brd4.create('segment', [[6,1], [6, 10]], {visible: false});
    var pRight1 = brd4.create('point', [6,-1],{fixed: true, name:'A', size:0, strokeColor:'black', fillColor: 'red', snapToGrid:true, label: {offset: [-15, 10], fontSize:function(){return 18*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});
    var pRight2 = brd4.create('point', [9, -1],{fixed: true, name:'B', size:0, strokeColor:'black', snapToGrid:true,label: {fontSize:function(){return 18*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});
    var pRight3 = brd4.create('glider', [6 , 4, lineRight],{visible: true, name:'C', size:2,  strokeColor:'black', snapToGrid:true,label: {offset: [-3,20], fontSize:function(){return 18*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});


    //Sides of the triangle
    var AcuteAB = brd4.create('segment', [pAcute1, pAcute2], {strokeColor:'blue', strokeWidth:1, fixed:true});
    var AcuteAC = brd4.create('segment', [pAcute1, pAcute3], {strokeColor:'blue', strokeWidth:1, fixed:true});
    var AcuteCB = brd4.create('segment', [pAcute2, pAcute3], {strokeColor:'blue', strokeWidth:1, fixed:true});
    brd4.create('polygon', [pAcute1, pAcute2, pAcute3],{fixed:true, strokeWidth:2, fillColor:'white', fillOpacity:1, borders:{fixed:true, strokeColor:'blue'},visible:true});

    var ObtuseAB = brd4.create('segment', [pObtuse1, pObtuse2], {strokeColor:'blue', strokeWidth:1, fixed:true});
    var ObtuseAC = brd4.create('segment', [pObtuse1, pObtuse3], {strokeColor:'blue', strokeWidth:1, fixed:true});
    var ObtuseCB = brd4.create('segment', [pObtuse2, pObtuse3], {strokeColor:'blue', strokeWidth:1, fixed:true});
    brd4.create('polygon', [pObtuse1, pObtuse2, pObtuse3],{fixed:true, strokeWidth:2, fillColor:'white', fillOpacity:1, borders:{fixed:true, strokeColor:'blue'},visible:true});

    var rightAB = brd4.create('segment', [pRight1, pRight2], {strokeColor:'blue', strokeWidth:1, fixed:true});
    var rightAC = brd4.create('segment', [pRight1, pRight3], {strokeColor:'blue', strokeWidth:1, fixed:true});
    var rightCB = brd4.create('segment', [pRight2, pRight3], {strokeColor:'blue', strokeWidth:1, fixed:true});
    brd4.create('polygon', [pRight1, pRight2, pRight3],{fixed:true, strokeWidth:2, fillColor:'white', fillOpacity:1, borders:{fixed:true, strokeColor:'blue'},visible:true});


    //Angles
    var angObt1 = brd4.create('angle', [pAcute2, pAcute1, pAcute3],{visible: false, name: '', radius:1, strokeColor:'red', fillColor:'red', label: {color: 'red', offset: [0,0], fontSize:function(){return 0*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});
    brd4.create('angle', [pAcute2, pAcute1, pAcute3],{name: function(){ return (180*angObt1.Value()/Math.PI).toFixed(0)  + '°'}, radius:1, strokeColor:'red', fillColor:'red', label: {color: 'red', offset: [0,0], fontSize:function(){return 14*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});

    var angObt2 = brd4.create('angle', [pAcute1, pAcute3, pAcute2],{visible: false, name: '', radius:1, strokeColor:'red', fillColor:'red', label: {color: 'red', offset: [-10,0], fontSize:function(){return 0*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});
    brd4.create('angle', [pAcute1, pAcute3, pAcute2],{name: function(){ return (180*angObt2.Value()/Math.PI).toFixed(0)  + '°'}, radius:1, strokeColor:'purple', fillColor:'purple', label: {color: 'purple', offset: [-10,0], fontSize:function(){return 14*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});

    var angObt3 = brd4.create('angle', [pAcute3, pAcute2, pAcute1],{visible: false, name: '', radius:1, strokeColor:'red', fillColor:'red', label: {color: 'red', offset: [-15,0], fontSize:function(){return 0*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});
    brd4.create('angle', [pAcute3, pAcute2, pAcute1],{name: function(){ return (180*angObt3.Value()/Math.PI).toFixed(0)  + '°'}, radius:1, strokeColor:'green', fillColor:'green', label: {color: 'green', offset: [-15,0], fontSize:function(){return 14*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});

    //var angg = brd4.create('angle', [[50, 0], pAcute1, pAcute2],{radius:1, strokeColor:'green', fillColor:'green',visible:false});

    var angAc1 = brd4.create('angle', [pObtuse2, pObtuse1, pObtuse3],{visible: false, name: '', radius:1, strokeColor:'blue', fillColor:'blue', label: {offset: [10, 0] , color: 'blue', fontSize:function(){return 0*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});
    brd4.create('angle', [pObtuse2, pObtuse1, pObtuse3],{name: function(){ return (180*angAc1.Value()/Math.PI).toFixed(0)  + '°'},  radius:1, strokeColor:'grey', fillColor:'grey', label: {offset: [0, 0] , color: 'grey', fontSize:function(){return 14*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});

    var angAc2 = brd4.create('angle', [pObtuse1, pObtuse3, pObtuse2],{visible: false, name: '', radius:1, strokeColor:'orange', fillColor:'orange',visible:true, label: {offset: [-5, 0] ,color: 'orange', fontSize:function(){return 0*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});
    brd4.create('angle', [pObtuse1, pObtuse3, pObtuse2],{name: function(){ return (180*angAc2.Value()/Math.PI).toFixed(0)  + '°'},  radius:1, strokeColor:'orange', fillColor:'orange',visible:true, label: {offset: [-10, -10] , color: 'orange', fontSize:function(){return 14*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});

    var angAc3 = brd4.create('angle', [pObtuse3, pObtuse2, pObtuse1],{visible: false, name: '', radius:1, strokeColor:'blue', fillColor:'blue', visible:true, label:{offset: [-10, -10] ,color: 'blue', fontSize:function(){return 0*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});
    brd4.create('angle', [pObtuse3, pObtuse2, pObtuse1],{name: function(){ return (180*angAc3.Value()/Math.PI).toFixed(0)  + '°'},  radius:1, strokeColor:'blue', fillColor:'blue', visible:true, label:{offset: [-10, -10] ,color: 'blue', fontSize:function(){return 14*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});



    var angRight1 = brd4.create('angle', [pRight2, pRight1, pRight3],{visible: false, name: '', radius:1, strokeColor:'yellow', fillColor:'yellow', label: {color: 'yellow', fontSize:function(){return 0*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});
    brd4.create('angle', [pRight2, pRight1, pRight3],{name: function(){ return (180*angRight1.Value()/Math.PI).toFixed(0)  + '°'}, radius:1, strokeColor:'yellow', fillColor:'yellow', label: {offset: [-15, -25] ,color: 'orange', fontSize:function(){return 14*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});

    var angRight2 = brd4.create('angle', [pRight1, pRight3, pRight2],{visible: false, name: '', radius:1, strokeColor:'purple', fillColor:'purple',visible:true, label: {color: 'purple', fontSize:function(){return 0*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});
    brd4.create('angle', [pRight1, pRight3, pRight2],{name: function(){ return (180*angRight2.Value()/Math.PI).toFixed(0)  + '°'}, radius:1, strokeColor:'purple', fillColor:'purple',visible:true, label: {offset: [0, -15],color: 'purple', fontSize:function(){return 14*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});

    var angRight3 = brd4.create('angle', [pRight3, pRight2, pRight1],{visible: false, name: '', radius:1, strokeColor:'green', fillColor:'green', visible:true, label:{color: 'green', fontSize:function(){return 0*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});
    brd4.create('angle', [pRight3, pRight2, pRight1],{name: function(){ return (180*angRight3.Value()/Math.PI).toFixed(0)  + '°'}, radius:1, strokeColor:'green', fillColor:'green', visible:true, label:{ color: 'green', fontSize:function(){return 14*brd4.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});



    //pAcute3.on('down', function(){i=0; j=0; return;});
    //pAcute2.on('down', function(){i=0; j=0;  return;});
    //pAcute1.on('down', function(){i=0; j=0;  return;});

    //Texts

  //  var Acuteceles = brd4.create('text', [0.5, -2, 'Acute '],{visible: true, fixed: true, CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(16*brd4.canvasWidth/500.)}});
  //  var Obtuseuilateral = brd4.create('text', [-7, -2, 'Obtuse '],{visible: true, fixed: true, CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(16*brd4.canvasWidth/500.)}});
  //  var right = brd4.create('text', [5.8, -2, 'Right - angled '],{visible: true, fixed: true, CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(16*brd4.canvasWidth/500.)}});


    brd4.unsuspendUpdate();
  },
  box1: function () {
    var brd1 = JXG.JSXGraph.initBoard('jxgbox1a',{boundingbox: [-3, 3, 3, -3],
        keepaspectratio: true, axis:false, ticks:{visible:false},
        grid:true, showCopyright:false, showNavigation:false,
        pan:{enabled:false}, zoom:{enabled:false}});

    brd1.suspendUpdate();
    brd1.options.layer['circle'] =8;
    brd1.options.layer['point'] =14;
    brd1.options.layer['glider'] =15;
    brd1.options.layer['segment'] =8;
    brd1.options.layer['text'] =17;

    const TitleProps = {
    fixed: true,
    anchorX: 'middle',
    anchorY: 'middle',
    CssStyle:'fontFamily:Oswald',
    fontSize:function(){return Math.round(32*brd1.canvasWidth/800.)}
    };
    const SubTitleProps = {
    fixed: true,
    anchorX: 'middle',
    anchorY: 'middle',
    CssStyle:'fontFamily:Oswald',
    fontSize:function(){return Math.round(24*brd1.canvasWidth/800.)}
    };
    const TextProps = {
    fixed: true,
    anchorX: 'middle',
    anchorY: 'middle',
    CssStyle:'fontFamily:Oswald',
    fontSize:function(){return Math.round(24*brd1.canvasWidth/800.)},
    highlight:false
    };
    const LabelProps = {
    fixed: true,
    anchorX: 'middle',
    anchorY: 'middle',
    offset:[5, -15],
    CssStyle:'fontFamily:Oswald',
    fontSize:function(){return Math.round(12*brd1.canvasWidth/800.)},
    highlight:false
    };
    const PointProps = {
    name:'O',
    color:'black',
    fixed: true,
    visible:true,
    highlight:false,
    size:function(){return Math.round(2*brd1.canvasWidth/800.)},
    label:LabelProps
    }
    const PointB = {
    name:'B',
    color:'black',
    fixed: true,
    visible:true,
    size:function(){return Math.round(2*brd1.canvasWidth/800.)},
    label:LabelProps
    }

    //Title and subtitle
    var title1 = brd1.create('text', [0, 2.5, '<b> Trigonometric Ratios <b>'], TitleProps);
    brd1.create('text', [0, 2.2, '(Drag Point A on the Unit Circle)'], SubTitleProps);

    //Circle
    var center = brd1.create('point', [0, 0], PointProps),
        p2 = brd1.create('point', [1, 0], {name:'', size:0, fixed: true}),
        p3 = brd1.create('point', [0, 1], {name:'', size:0, fixed: true}),
        p4 = brd1.create('point', [-1, 0], {name:'', size:0, fixed: true}),
        p5 = brd1.create('point', [0, -1], {name:'', size:0, fixed: true}),
        p6 = brd1.create('point', [1/Math.sqrt(2),1/Math.sqrt(2)], {name:'', size:0, fixed: true}),
        p7 = brd1.create('point', [1/2, Math.sqrt(3)/2], {name:'', size:0, fixed: true}),
        p8 = brd1.create('point', [Math.sqrt(3)/2, 1/2], {name:'', size:0, fixed: true}),
        c1 = brd1.create('circle', [center, p2], {fixed:true, highlight:false});
  //
  const GliderLabelProps = {
  fixed: true,
  anchorX: 'middle',
  anchorY: 'middle',
  offset:[25, 15],
  CssStyle:'fontFamily:Oswald',
  fontSize:function(){return Math.round(12*brd1.canvasWidth/800.)},
  highlight:false
  };
  const GliderProps = {
  name:'A (Drag me!)',
  strokeColor:'black',
  filColor:'red',
  highlight:false,
  fixed: false,
  visible:true,
  size:function(){return Math.round(2*brd1.canvasWidth/800.)},
  attractors:[p2, p3, p4, p5],
  attractorDistance:0.2,
  snatchDistance:0.15,
  label:GliderLabelProps
  }
  //c1.setLabel('Unit Circle')
  //c1.label.setAttribute({visible:false, offset:[25, 0], CssStyle:'fontFamily:Oswald', fontSize:16});
  //c1.on('over', function () {this.label.setAttribute({visible:true});});
  //c1.on('out', function () {this.label.setAttribute({visible:false});});

    var dragMe = brd1.create('glider', [1/Math.sqrt(2),1/Math.sqrt(2), c1], GliderProps);
    var horizontal = brd1.create('segment', [[-5,0], [5,0]], {fixed: true, strokeWidth: 0, strokeColor: 'grey'});
    var vertical = brd1.create('segment', [[0, -5], [0, 5]], {fixed: true, strokeWidth: 0, strokeColor: 'grey'});

    var hypotenuse = brd1.create('segment', [center, dragMe], {fixed: true, strokeWidth: 1.5, strokeColor: 'black'});
    var opposite = brd1.create('perpendicular', [horizontal, dragMe], {fixed: true, strokeWidth:1, strokeColor: 'red', dash:1});
    var adjacent = brd1.create('perpendicular', [vertical, dragMe], {fixed: true, strokeWidth:1, strokeColor: 'green', dash:1});

    //Height and base
    var pointOpp1 = brd1.create('point', [()=>dragMe.X() , ()=>dragMe.Y()], {visible: false, fixed: true});
    var pointOpp2 = brd1.create('point', [()=>dragMe.X() , 0], {visible: false, fixed: true});

    var pointAdj1 = brd1.create('point', [0 , 0], {visible: false, fixed: true});
    var pointAdj2 = brd1.create('point', [function(){return dragMe.X()} , 0], PointB);

    //var oppositeLength = brd1.create('segment', [pointOpp1, pointOpp2],  {fixed: true, strokeColor:'black', strokeWidth: 1.5});
    //var adjacentLength = brd1.create('segment', [pointAdj1, pointAdj2],  {fixed: true, strokeColor:'black', strokeWidth: 1.5});
    brd1.create('polygon', [pointOpp1, pointOpp2, center],{vertices:{visible:false}, borders:{strokeColor:'black', strokeWidth:2}, fillColor:'white', highlight:false, fillOpacity:1})
    var theta = brd1.create('angle', [p2, center, dragMe],{name:()=> '&theta; = '+(JXG.Math.Geometry.rad(p2, center, dragMe)*180/Math.PI).toFixed(1) +'°' ,  visible: true, radius:0.4, strokeColor:'orange', fillColor:'orange', label: {color: 'orange' ,offset: [0 , 0], fontSize:function(){return 12*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});
    brd1.create('segment', [[1.25, 0], [1.25, ()=>dragMe.Y()]],  {fixed: true, firstArrow:true, lastArrow:true, strokeColor:'grey', strokeWidth: 1.5});
    brd1.create('segment', [[0, 1.25], [()=>dragMe.X(), 1.25]],  {fixed: true, firstArrow:true, lastArrow:true, strokeColor:'grey', strokeWidth: 1.5});

    var txt1 = brd1.create('text', [1.275, function(){return pointOpp1.Y()/2}, function(){return 'Y = '+ (dragMe.Y()).toFixed(2)}],{fixed: true, anchorX: 'left', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(10*brd1.canvasWidth/500.)}},);
    var txt2 = brd1.create('text', [function(){return pointAdj2.X()/2}, 1.25, function(){return 'X = ' + (dragMe.X()).toFixed(2)}],{fixed: true, anchorX: 'middle', anchorY: 'bottom', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(10*brd1.canvasWidth/500.)}},);

    //Tetxs

    var sin1 = brd1.create('text', [-2., -1.5, ()=>'sin (&theta;) = Height/Hypotenuse = X = '+ (dragMe.Y()).toFixed(3)],{fixed: true, anchorX: 'left', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
    //var sin2 = brd1.create('text', [function(){return sin1.X()+0.5}, function(){return sin1.Y()+0.7}, '<u> opposite </u>'],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
    //var sin3 = brd1.create('text', [function(){return sin1.X()+0.5}, function(){return sin1.Y()-0.7}, 'hypotenuse'],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
    //var sin4 = brd1.create('text', [function(){return sin1.X()+0.8}, function(){return sin1.Y()}, '='],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
    //var sin5 = brd1.create('text', [function(){return sin1.X()+1.0}, function(){return sin1.Y()}, function(){return (oppositeLenght.L()/hypotenuse.L()).toFixed(3)}],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);

    //var arr1 = brd1.create('text', [function(){return sin1.X()+1.6}, function(){return sin1.Y()}, '→'],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);

  //  var csc1 = brd1.create('text', [function(){return sin1.X()+20}, function(){return sin1.Y()}, 'csc (&theta;) = '],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
  //  var csc2 = brd1.create('text', [function(){return csc1.X()+5}, function(){return csc1.Y()+0.7}, '<u> hypotenuse </u>'],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
  //  var csc3 = brd1.create('text', [function(){return csc1.X()+5}, function(){return csc1.Y()-0.7}, 'opposite'],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
  //  var csc4 = brd1.create('text', [function(){return csc1.X()+8}, function(){return csc1.Y()}, '='],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
  //  var csc5 = brd1.create('text', [function(){return csc1.X()+10}, function(){return csc1.Y()}, function(){return (hypotenuse.L()/oppositeLenght.L()).toFixed(3)}],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
    var cos1 = brd1.create('text', [-2., ()=>sin1.Y()-0.5, ()=>'cos (&theta;) = Base/Hypotenuse = Y = '+ (dragMe.X()).toFixed(3)],{fixed: true, anchorX: 'left', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
  /*  var cos2 = brd1.create('text', [function(){return cos1.X()+0.5}, function(){return cos1.Y()+0.7}, '<u> adjacent </u>'],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
    var cos3 = brd1.create('text', [function(){return cos1.X()+0.5}, function(){return cos1.Y()-0.7}, 'hypotenuse'],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
    var cos4 = brd1.create('text', [function(){return cos1.X()+0.8}, function(){return cos1.Y()}, '='],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
    var cos5 = brd1.create('text', [function(){return cos1.X()+1.0}, function(){return cos1.Y()}, function(){return (adjacentLenght.L()/hypotenuse.L()).toFixed(3)}],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);

    var arr2 = brd1.create('text', [function(){return cos1.X()+1.6}, function(){return cos1.Y()}, '→'],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
*/
  //  var sec1 = brd1.create('text', [function(){return cos1.X()+20}, function(){return cos1.Y()}, 'sec (&theta;) = '],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
  //  var sec2 = brd1.create('text', [function(){return sec1.X()+5}, function(){return sec1.Y()+0.7}, '<u> hypotenuse </u>'],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
//    var sec3 = brd1.create('text', [function(){return sec1.X()+5}, function(){return sec1.Y()-0.7}, 'adjacent'],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
//    var sec4 = brd1.create('text', [function(){return sec1.X()+8}, function(){return sec1.Y()}, '='],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
//    var sec5 = brd1.create('text', [function(){return sec1.X()+10}, function(){return sec1.Y()}, function(){return (hypotenuse.L()/adjacentLenght.L()).toFixed(3)}],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);

    var tan1 = brd1.create('text', [-2, ()=>sin1.Y()-1.0, ()=>'tan (&theta;) = Height/Base = X/Y = '+ (dragMe.Y()/dragMe.X()).toFixed(3)],{fixed: true, anchorX: 'left', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
/*    var tan2 = brd1.create('text', [function(){return tan1.X()+0.5}, function(){return tan1.Y()+0.7}, '<u> opposite </u>'],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
    var tan3 = brd1.create('text', [function(){return tan1.X()+0.5}, function(){return tan1.Y()-0.7}, 'adjacent'],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
    var tan4 = brd1.create('text', [function(){return tan1.X()+0.8}, function(){return tan1.Y()}, '='],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
    var tan5 = brd1.create('text', [function(){return tan1.X()+1.0}, function(){return tan1.Y()}, function(){return (oppositeLenght.L()/adjacent.L()).toFixed(3)}],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);

    var arr3 = brd1.create('text', [function(){return tan1.X()+1.6}, function(){return tan1.Y()}, '→'],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
*/
    //var cot1 = brd1.create('text', [function(){return tan1.X()+20}, function(){return tan1.Y()}, 'cot (&theta;) = '],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
    //var cot2 = brd1.create('text', [function(){return cot1.X()+5}, function(){return cot1.Y()+0.7}, '<u> adjacent </u>'],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
    //var cot3 = brd1.create('text', [function(){return cot1.X()+5}, function(){return cot1.Y()-0.7}, 'opposite'],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
    //var cot4 = brd1.create('text', [function(){return cot1.X()+8}, function(){return cot1.Y()}, '='],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
    //var cot5 = brd1.create('text', [function(){return cot1.X()+10}, function(){return cot1.Y()}, function(){return (adjacentLenght.L()/oppositeLenght.L()).toFixed(3)}],{fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
    brd1.unsuspendUpdate();
  },
  box2: function () {
  JXG.Options.board.minimizeReflow = 'none';
  var brd2 = JXG.JSXGraph.initBoard('jxgbox1b',{boundingbox: [-7, 20, 20, -10],
      keepaspectratio: true, axis:false, ticks:false,
      grid:true, showCopyright:false, showNavigation:false,
      pan:{enabled:false}, zoom:{enabled:false}});

  brd2.suspendUpdate();

  brd2.options.layer['image'] =14;
  brd2.create('segment', [[0,-25],[0, 25]], {strokeColor:'grey', strokeWidth:1});
  brd2.create('segment', [[-25,0],[25, 0]],{strokeColor:'grey', strokeWidth:1});
  //Put the values ​​with a number after the comma
  //var txtValues = brd2.create('text', [15, -8, 'Put the values ​​with a number after the comma'],{visible: true, fixed: true, anchorX: 'start', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(8*brd2.canvasWidth/500.)}},);

  //Images
  var person = brd2.create('image', ['/assets/hiking.svg', [15, 0], [2, 2]], {visible: true, fixed: true});
  var tryMe = brd2.create('image', ['/assets/test.svg', [10, 12], [2, 2]], {visible: true, fixed: true});

  var ok0 = brd2.create('image', ['/assets/check.svg', [14, 12.5], [1.5, 1.5]], {visible: false, fixed: true});
  var ok1 = brd2.create('image', ['/assets/check.svg', [14, 12.5], [1.5 ,1.5]], {visible: false, fixed: true});
  var ok2 = brd2.create('image', ['/assets/check.svg', [14, 12.5], [1.5 ,1.5]], {visible: false, fixed: true});
  var ok3 = brd2.create('image', ['/assets/check.svg', [14, 12.5], [1.5 ,1.5]], {visible: false, fixed: true});
  var ok4 = brd2.create('image', ['/assets/check.svg', [14, 12.5], [1.5 ,1.5]], {visible: false, fixed: true});
  var ok5 = brd2.create('image', ['/assets/check.svg', [14, 12.5], [1.5 ,1.5]], {visible: false, fixed: true});

  var cross0 = brd2.create('image', ['/assets/cross.svg', [14, 12.5], [1.5, 1.5]], {visible: false, fixed: true});
  var cross1 = brd2.create('image', ['/assets/cross.svg', [14, 12.5], [1.5 ,1.5]], {visible: false, fixed: true});
  var cross2 = brd2.create('image', ['/assets/cross.svg', [14, 12.5], [1.5 ,1.5]], {visible: false, fixed: true});
  var cross3 = brd2.create('image', ['/assets/cross.svg', [14, 12.5], [1.5 ,1.5]], {visible: false, fixed: true});
  var cross4 = brd2.create('image', ['/assets/cross.svg', [14, 12.5], [1.5 ,1.5]], {visible: false, fixed: true});
  var cross5 = brd2.create('image', ['/assets/cross.svg', [14, 12.5], [1.5 ,1.5]], {visible: false, fixed: true});

  tryMe.setLabel('Try')
  tryMe.label.setAttribute({visible:false, offset:[15, -15], CssStyle:'fontFamily:Oswald', fontSize:16});
  tryMe.on('over', function () {this.label.setAttribute({visible:true});});
  tryMe.on('out', function () {this.label.setAttribute({visible:false});});



  //***********Empire States**********//

  //Title
  var titleES = brd2.create('text', [6.5, 17, 'How far is the hiker from the Empire State building?'],{display:'internal',visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(32*brd2.canvasWidth/800.)}},);

  brd2.create('text', [6.5, 15.5, '(Your answer must be correct to two decimal places)'],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(20*brd2.canvasWidth/800.)}},);

  //Image
  var empireStates = brd2.create('image', ['/assets/empire-state-building.svg', [-4, 0], [8, 10]], {visible: true, fixed: true});

  var hES = 10;

  var pAng1ES = brd2.create('point', [0, hES], {visible: false, fixed: true});
  var pAng2ES = brd2.create('point', [15, 0], {visible: false, fixed: true});
  var pAng3ES = brd2.create('point', [0, 0], {visible: false, fixed: true});

  //Arrows
  var horizontalES = brd2.create('segment', [[0, -2], [function(){return pAng2ES.X()}, -2]], {visible: true, fixed: true, strokeWidth: 1, strokeColor: 'black', firstArrow:true, lastArrow:true });
  var verticalES = brd2.create('segment', [[-3, 0], [-3, hES]], {visible: true, fixed: true, strokeWidth: 1, strokeColor: 'black', firstArrow:true, lastArrow:true });
  var hypotenuseES = brd2.create('segment', [[function(){return pAng2ES.X()}, 0], [0, hES]], {visible: true, fixed: true, strokeWidth: 1, strokeColor: 'black', firstArrow:true, lastArrow:true });

  //Tetx
  var txt1ES = brd2.create('text', [function(){return horizontalES.L()/2}, -1.5 , 'Distance'],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(12*brd2.canvasWidth/500.)}},);
  var txt2ES = brd2.create('text', [-5, function(){return verticalES.L()/2} , '443.2 m'],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(12*brd2.canvasWidth/500.)}},);

  var angleES = brd2.create('angle', [pAng1ES, pAng2ES, pAng3ES],{name: '40°' ,  visible: true, radius: 2, strokeColor:'blue', fillColor:'blue', label: {color: 'blue' ,offset: [-20 , -10], fontSize:function(){return 18*brd2.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});

  var txt3ES = brd2.create('text', [5, 13 , 'distance ='],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(18*brd2.canvasWidth/500.)}},);
  var op1ES = brd2.create('input', [7, 13, '', ''], {fixed: true, cssStyle: 'fontFamily:Oswald; width:10%; background-color:#008CBA;border: 1px solid black;border-radius: 3.5px;', fontSize:function(){return Math.round(16*brd2.canvasWidth/500.)}, fixed:true,parse:true});


  //***********TAJ MAHAL**********//
  //Title
  var titleTM = brd2.create('text', [6.5, 17, 'How tall is the Taj Mahal?'],{visible: false, display:'internal', fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(22*brd2.canvasWidth/500.)}},);

  //Image
  var tajMahal = brd2.create('image', ['/assets/taj-mahal.svg', [-3, -0.5], [6, 6]], {visible: false, fixed: true});

  var pAng1TM = brd2.create('point', [0, 5], {visible: false, fixed: true});
  var pAng2TM = brd2.create('point', [15, 0], {visible: false, fixed: true});
  var pAng3TM = brd2.create('point', [0, 0], {visible: false, fixed: true});

  //Arrows
  var horizontalTM = brd2.create('segment', [[0, -2], [function(){return pAng2TM.X()}, -2]], {visible: false, fixed: true, strokeWidth: 1, strokeColor: 'black', firstArrow:true, lastArrow:true });
  var verticalTM = brd2.create('segment', [[-3, 0], [-3, 5]], {visible: false, fixed: true, strokeWidth: 1, strokeColor: 'black', firstArrow:true, lastArrow:true });
  var hypotenuseTM = brd2.create('segment', [[function(){return pAng2TM.X()}, 0], [0, 5]], {visible: false, fixed: true, strokeWidth: 1, strokeColor: 'black', firstArrow:true, lastArrow:true });

  //Tetx
  var txt1TM = brd2.create('text', [function(){return horizontalTM.L()/2}, -1.5 , '131.7 m'],{visible: false, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(12*brd2.canvasWidth/500.)}},);
  var txt2TM = brd2.create('text', [-4, function(){return verticalTM.L()/2} , 'h'],{visible: false, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(12*brd2.canvasWidth/500.)}},);

  var angleTM = brd2.create('angle', [pAng1TM, pAng2TM, pAng3TM],{name: '29°' ,  visible: false, radius: 2, strokeColor:'blue', fillColor:'blue', label: {color: 'blue' ,offset: [-20 , -10], fontSize:function(){return 18*brd2.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});

  var txt3TM = brd2.create('text', [5, 13 , 'height ='],{visible: false, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(18*brd2.canvasWidth/500.)}},);
  //var op1TM = brd2.create('input', [7, 13, ' ', ''], {fixed: true, cssStyle: 'fontFamily:Oswald; width:10%; background-color:#008CBA;border: 1px solid black;border-radius: 3.5px;', fontSize:function(){return Math.round(16*brd2.canvasWidth/500.)}, fixed:true,parse:true});


  //***********Eiffel Tower**********//
  //Title
  var titleET = brd2.create('text', [6.5, 17, 'How far is the hiker from the Eiffel Tower?'],{display:'internal', visible: false, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(22*brd2.canvasWidth/500.)}},);

  //Image
  var eiffelTower = brd2.create('image', ['/assets/eiffel-tower.svg', [-2.5, 0], [5, 7]], {visible: false, fixed: true});

  var hET = 7;

  var pAng1ET = brd2.create('point', [0, hET], {visible: false, fixed: true});
  var pAng2ET = brd2.create('point', [13, 0], {visible: false, fixed: true});
  var pAng3ET = brd2.create('point', [0, 0], {visible: false, fixed: true});

  //Arrows
  var horizontalET = brd2.create('segment', [[0, -2], [function(){return pAng2ET.X()}, -2]], {visible: false, fixed: true, strokeWidth: 1, strokeColor: 'black', firstArrow:true, lastArrow:true });
  var verticalET = brd2.create('segment', [[-3, 0], [-3, hET]], {visible: false, fixed: true, strokeWidth: 1, strokeColor: 'black', firstArrow:true, lastArrow:true });
  var hypotenuseET = brd2.create('segment', [[function(){return pAng2ET.X()}, 0], [0, hET]], {visible: false, fixed: true, strokeWidth: 1, strokeColor: 'black', firstArrow:true, lastArrow:true });

  //Tetx
  var txt1ET = brd2.create('text', [function(){return horizontalET.L()/2}, -1.5 , 'Distance'],{visible: false, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(12*brd2.canvasWidth/500.)}},);
  var txt2ET = brd2.create('text', [-4, function(){return verticalET.L()/2} , '324 m'],{visible: false, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(12*brd2.canvasWidth/500.)}},);

  var angleET = brd2.create('angle', [pAng1ET, pAng2ET, pAng3ET],{name: '36.1°' ,  visible: false, radius: 2, strokeColor:'blue', fillColor:'blue', label: {color: 'blue' ,offset: [-25 , -10], fontSize:function(){return 18*brd2.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});

  var txt3ET = brd2.create('text', [5, 13 , 'distance ='],{visible: false, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(18*brd2.canvasWidth/500.)}},);
  //var op1ET = brd2.create('input', [7, 13, ' ', ''], {fixed: true, cssStyle: 'fontFamily:Oswald; width:10%; background-color:#008CBA;border: 1px solid black;border-radius: 3.5px;', fontSize:function(){return Math.round(16*brd2.canvasWidth/500.)}, fixed:true,parse:true});

  //***********Giza**********//
  //Title
  var titleGI = brd2.create('text', [6.5, 17, 'What is the angle &theta; ?'],{parse:true, useMathJax:true,visible: false, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(22*brd2.canvasWidth/500.)}},);

  //Image
  var giza = brd2.create('image', ['/assets/sphinx-of-giza.svg', [-2, -0.], [4, 4]], {visible: false, fixed: true});

  var hGI = 4;

  var pAng1GI = brd2.create('point', [0, hGI], {visible: false, fixed: true});
  var pAng2GI = brd2.create('point', [15, 0], {visible: false, fixed: true});
  var pAng3GI = brd2.create('point', [0, 0], {visible: false, fixed: true});

  //Arrows
  var horizontalGI = brd2.create('segment', [[0, -2], [function(){return pAng2GI.X()}, -2]], {visible: false, fixed: true, strokeWidth: 1, strokeColor: 'black', firstArrow:true, lastArrow:true });
  var verticalGI = brd2.create('segment', [[-3, 0], [-3, hGI]], {visible: false, fixed: true, strokeWidth: 1, strokeColor: 'black', firstArrow:true, lastArrow:true });
  var hypotenuseGI = brd2.create('segment', [[function(){return pAng2GI.X()}, 0], [0, hGI]], {visible: false, fixed: true, strokeWidth: 1, strokeColor: 'black', firstArrow:true, lastArrow:true });

  //Tetx
  var txt1GI = brd2.create('text', [function(){return horizontalGI.L()/2}, -1.5 , '50 m'],{visible: false, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(12*brd2.canvasWidth/500.)}},);
  var txt2GI = brd2.create('text', [-4, function(){return verticalGI.L()/2} , '20 m'],{visible: false, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(12*brd2.canvasWidth/500.)}},);

  var angleGI = brd2.create('angle', [pAng1GI, pAng2GI, pAng3GI],{name: '&theta;' ,  visible: false, radius: 2, strokeColor:'blue', fillColor:'blue', label: {color: 'blue' ,offset: [-20 , -10], fontSize:function(){return 18*brd2.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});

  var txt3GI = brd2.create('text', [5, 13 , '&theta;(°) ='],{visible: false, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(18*brd2.canvasWidth/500.)}},);


  //***********Statue of Liberty**********//
  //Title
  var titleSTAT = brd2.create('text', [6.5, 17, 'What is the angle &theta; ?'],{visible: false, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(22*brd2.canvasWidth/500.)}},);

  //Image
  var STAT = brd2.create('image', ['/assets/statue-of-liberty.svg', [-2.5, 0], [5, 6]], {visible: false, fixed: true});

  var hSTAT = 6;

  var pAng1STAT = brd2.create('point', [0, hSTAT], {visible: false, fixed: true});
  var pAng2STAT = brd2.create('point', [10, 0], {visible: false, fixed: true});
  var pAng3STAT = brd2.create('point', [0, 0], {visible: false, fixed: true});

  //Arrows
  var horizontalSTAT = brd2.create('segment', [[0, -2], [function(){return pAng2STAT.X()}, -2]], {visible: false, fixed: true, strokeWidth: 1, strokeColor: 'black', firstArrow:true, lastArrow:true });
  var verticalSTAT = brd2.create('segment', [[-3, 0], [-3, hSTAT]], {visible: false, fixed: true, strokeWidth: 1, strokeColor: 'black', firstArrow:true, lastArrow:true });
  var hypotenuseSTAT = brd2.create('segment', [[function(){return pAng2STAT.X()}, 0], [0, hSTAT]], {visible: false, fixed: true, strokeWidth: 1, strokeColor: 'black', firstArrow:true, lastArrow:true });

  //Tetx
  var txt1STAT = brd2.create('text', [function(){return horizontalSTAT.L()/2}, -1.5 , '27 m'],{visible: false, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(12*brd2.canvasWidth/500.)}},);
  var txt2STAT = brd2.create('text', [-4, function(){return verticalSTAT.L()/2} , '93 m'],{visible: false, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(12*brd2.canvasWidth/500.)}},);

  var angleSTAT = brd2.create('angle', [pAng1STAT, pAng2STAT, pAng3STAT],{name: '&theta;' ,  visible: false, radius: 2, strokeColor:'blue', fillColor:'blue', label: {color: 'blue' ,offset: [-20 , -10], fontSize:function(){return 18*brd2.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});

  var txt3STAT = brd2.create('text', [5, 13 , '&theta;(°) ='],{visible: false, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(18*brd2.canvasWidth/500.)}},);


  //***********Burj Khalifa**********//
  //Title
  var titleBURJ = brd2.create('text', [-5, 17, "What is the height of the world's tallest building, Burj Khalifa?"],{visible: false, fixed: true, anchorX: 'start', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(22*brd2.canvasWidth/500.)}},);

  //Image
  var BURJ = brd2.create('image', ['/assets/burj-khalifa.svg', [-4, -0.5], [8, 12]], {visible: false, fixed: true});

  var hBURJ = 11;

  var pAng1BURJ = brd2.create('point', [0, hBURJ], {visible: false, fixed: true});
  var pAng2BURJ = brd2.create('point', [12, 0], {visible: false, fixed: true});
  var pAng3BURJ = brd2.create('point', [0, 0], {visible: false, fixed: true});

  //Arrows
  var horizontalBURJ = brd2.create('segment', [[0, -2], [function(){return pAng2BURJ.X()}, -2]], {visible: false, fixed: true, strokeWidth: 1, strokeColor: 'black', firstArrow:true, lastArrow:true });
  var verticalBURJ = brd2.create('segment', [[-3, 0], [-3, hBURJ]], {visible: false, fixed: true, strokeWidth: 1, strokeColor: 'black', firstArrow:true, lastArrow:true });
  var hypotenuseBURJ = brd2.create('segment', [[function(){return pAng2BURJ.X()}, 0], [0, hBURJ]], {visible: false, fixed: true, strokeWidth: 1, strokeColor: 'black', firstArrow:true, lastArrow:true });

  //Tetx
  var txt1BURJ = brd2.create('text', [function(){return horizontalBURJ.L()/2}, -1.5 , '749.8 m'],{visible: false, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(12*brd2.canvasWidth/500.)}},);
  var txt2BURJ = brd2.create('text', [-4, function(){return verticalBURJ.L()/2} , 'h'],{visible: false, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(12*brd2.canvasWidth/500.)}},);

  var angleBURJ = brd2.create('angle', [pAng1BURJ, pAng2BURJ, pAng3BURJ],{name: '47.9°' ,  visible: false, radius: 2, strokeColor:'blue', fillColor:'blue', label: {color: 'blue' ,offset: [-25 , -10], fontSize:function(){return 18*brd2.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});

  var txt3BURJ = brd2.create('text', [5, 13 , 'height ='],{visible: false, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(18*brd2.canvasWidth/500.)}},);


  //REDO AND UNDO
  var redo = brd2.create('image', ['/assets/redo.svg', [7.5, -8], [2, 2]], {visible: true, fixed: true});
  var undo = brd2.create('image', ['/assets/undo.svg', [function(){return redo.X()-2.5}, function(){return redo.Y()}], [2 , 2]], {visible: true, fixed: true});

  redo.setLabel('Next')
  redo.label.setAttribute({visible:false, offset:[0, -15], CssStyle:'fontFamily:Oswald', fontSize:16});
  redo.on('over', function () {this.label.setAttribute({visible:true});});
  redo.on('out', function () {this.label.setAttribute({visible:false});});

  undo.setLabel('Previous')
  undo.label.setAttribute({visible:false, offset:[10, -15], CssStyle:'fontFamily:Oswald', fontSize:16});
  undo.on('over', function () {this.label.setAttribute({visible:true});});
  undo.on('out', function () {this.label.setAttribute({visible:false});});

  var i =0;
  var maxSteps = 4;

  function updateSteps(){
      eraseEverything();

      if (i<=0){

          titleES.setAttribute({visible: true});
          empireStates.setAttribute({visible: true});
          horizontalES.setAttribute({visible: true});
          verticalES.setAttribute({visible: true});
          hypotenuseES.setAttribute({visible: true});
          txt1ES.setAttribute({visible: true});
          txt2ES.setAttribute({visible: true});
          txt3ES.setAttribute({visible: true});
          angleES.setAttribute({visible: true});

          person.moveTo([15, 0], 500);
          pAng2ES.moveTo([15, 0], 500);

      }

      if(i==1){
          titleTM.setAttribute({visible: true});
          tajMahal.setAttribute({visible: true});
          horizontalTM.setAttribute({visible: true});
          verticalTM.setAttribute({visible: true});
          hypotenuseTM.setAttribute({visible: true});
          txt1TM.setAttribute({visible: true});
          txt2TM.setAttribute({visible: true});
          txt3TM.setAttribute({visible: true});
          angleTM.setAttribute({visible: true});

          person.moveTo([13, 0], 500);
          pAng2TM.moveTo([13, 0], 500);
          pAng2ES.moveTo([13, 0], 500);
      }

      if(i==2){
          titleET.setAttribute({visible: true});
          eiffelTower.setAttribute({visible: true});
          horizontalET.setAttribute({visible: true});
          verticalET.setAttribute({visible: true});
          hypotenuseET.setAttribute({visible: true});
          txt1ET.setAttribute({visible: true});
          txt2ET.setAttribute({visible: true});
          txt3ET.setAttribute({visible: true});
          angleET.setAttribute({visible: true});

          person.moveTo([15, 0], 500);
          pAng2ET.moveTo([15, 0], 500);
          pAng2TM.moveTo([15, 0], 500);

      }

      if(i==3){
          titleGI.setAttribute({visible: true});
          giza.setAttribute({visible: true});
          horizontalGI.setAttribute({visible: true});
          verticalGI.setAttribute({visible: true});
          hypotenuseGI.setAttribute({visible: true});
          txt1GI.setAttribute({visible: true});
          txt2GI.setAttribute({visible: true});
          txt3GI.setAttribute({visible: true});
          angleGI.setAttribute({visible: true});

          person.moveTo([10, 0], 500);
          pAng2GI.moveTo([10, 0], 500);
          pAng2ET.moveTo([10, 0], 500);

      }

      if(i==4){
          titleSTAT.setAttribute({visible: true});
          STAT.setAttribute({visible: true});
          horizontalSTAT.setAttribute({visible: true});
          verticalSTAT.setAttribute({visible: true});
          hypotenuseSTAT.setAttribute({visible: true});
          txt1STAT.setAttribute({visible: true});
          txt2STAT.setAttribute({visible: true});
          txt3STAT.setAttribute({visible: true});
          angleSTAT.setAttribute({visible: true});

          person.moveTo([12, 0], 500);
          pAng2STAT.moveTo([12, 0], 500);
          pAng2GI.moveTo([12, 0], 500);

      }

      if(i==5){
          titleBURJ.setAttribute({visible: true});
          BURJ.setAttribute({visible: true});
          horizontalBURJ.setAttribute({visible: true});
          verticalBURJ.setAttribute({visible: true});
          hypotenuseBURJ.setAttribute({visible: true});
          txt1BURJ.setAttribute({visible: true});
          txt2BURJ.setAttribute({visible: true});
          txt3BURJ.setAttribute({visible: true});
          angleBURJ.setAttribute({visible: true});
          person.moveTo([18, 0], 500);
          pAng2BURJ.moveTo([18, 0], 500);
          pAng2STAT.moveTo([18, 0], 500);

      }
  }

  function eraseEverything(){

      ok0.setAttribute({visible: false});
      cross0.setAttribute({visible: false});
      ok1.setAttribute({visible: false});
      cross1.setAttribute({visible: false});
      ok2.setAttribute({visible: false});
      cross2.setAttribute({visible: false});
      ok3.setAttribute({visible: false});
      cross3.setAttribute({visible: false});
      ok4.setAttribute({visible: false});
      cross4.setAttribute({visible: false});
      ok5.setAttribute({visible: false});
      cross5.setAttribute({visible: false});

      titleES.setAttribute({visible: false});
      empireStates.setAttribute({visible: false});
      horizontalES.setAttribute({visible: false});
      verticalES.setAttribute({visible: false});
      hypotenuseES.setAttribute({visible: false});
      txt1ES.setAttribute({visible: false});
      txt2ES.setAttribute({visible: false});
      txt3ES.setAttribute({visible: false});
      angleES.setAttribute({visible: false});

      titleTM.setAttribute({visible: false});
      tajMahal.setAttribute({visible: false});
      horizontalTM.setAttribute({visible: false});
      verticalTM.setAttribute({visible: false});
      hypotenuseTM.setAttribute({visible: false});
      txt1TM.setAttribute({visible: false});
      txt2TM.setAttribute({visible: false});
      txt3TM.setAttribute({visible: false});
      angleTM.setAttribute({visible: false});

      titleET.setAttribute({visible: false});
      eiffelTower.setAttribute({visible: false});
      horizontalET.setAttribute({visible: false});
      verticalET.setAttribute({visible: false});
      hypotenuseET.setAttribute({visible: false});
      txt1ET.setAttribute({visible: false});
      txt2ET.setAttribute({visible: false});
      txt3ET.setAttribute({visible: false});
      angleET.setAttribute({visible: false});

      titleGI.setAttribute({visible: false});
      giza.setAttribute({visible: false});
      horizontalGI.setAttribute({visible: false});
      verticalGI.setAttribute({visible: false});
      hypotenuseGI.setAttribute({visible: false});
      txt1GI.setAttribute({visible: false});
      txt2GI.setAttribute({visible: false});
      txt3GI.setAttribute({visible: false});
      angleGI.setAttribute({visible: false});

      titleSTAT.setAttribute({visible: false});
      STAT.setAttribute({visible: false});
      horizontalSTAT.setAttribute({visible: false});
      verticalSTAT.setAttribute({visible: false});
      hypotenuseSTAT.setAttribute({visible: false});
      txt1STAT.setAttribute({visible: false});
      txt2STAT.setAttribute({visible: false});
      txt3STAT.setAttribute({visible: false});
      angleSTAT.setAttribute({visible: false});

      titleBURJ.setAttribute({visible: false});
      BURJ.setAttribute({visible: false});
      horizontalBURJ.setAttribute({visible: false});
      verticalBURJ.setAttribute({visible: false});
      hypotenuseBURJ.setAttribute({visible: false});
      txt1BURJ.setAttribute({visible: false});
      txt2BURJ.setAttribute({visible: false});
      txt3BURJ.setAttribute({visible: false});
      angleBURJ.setAttribute({visible: false});

      txt1ES.setText('Distance ');
      txt2TM.setText('h');
      txt1ET.setText('Distance ');
      angleGI.setAttribute({name: '&theta;(°)'});
      angleSTAT.setAttribute({name: '&theta;(°)'});
      txt2BURJ.setText('h');

  }

  redo.on('down',function(){
      i = i+1;
      if (i > maxSteps){
          i = maxSteps;
      }
      updateSteps();
      let magicGraph = brd2.containerObj;
      let inputFields = magicGraph.querySelectorAll("input");
          for (let inputField of inputFields) {
                inputField.value = "";}
  });

  undo.on('down',function(){
      i=i-1;
      if (i < 0){
          i = 0;
      }
      eraseEverything();
      updateSteps();
      let magicGraph = brd2.containerObj;
      let inputFields = magicGraph.querySelectorAll("input");
          for (let inputField of inputFields) {
                inputField.value = "";}
  });


  function check(){

      if((i == 0 && op1ES.Value() <= 528.19 && op1ES.Value() >= 528.18)){

          ok0.setAttribute({visible: true});
          cross0.setAttribute({visible: false});
          ok1.setAttribute({visible: false});
          cross1.setAttribute({visible: false});
          ok2.setAttribute({visible: false});
          cross2.setAttribute({visible: false});
          ok3.setAttribute({visible: false});
          cross3.setAttribute({visible: false});
          ok4.setAttribute({visible: false});
          cross4.setAttribute({visible: false});
          ok5.setAttribute({visible: false});
          cross5.setAttribute({visible: false});
          txt1ES.setText(function(){return 'Distance = ' + op1ES.Value() + 'm'});

          console.log('i == 0 BIEN');
      }

      else if(i == 0){
          ok0.setAttribute({visible: false});
          cross0.setAttribute({visible: true});
          ok1.setAttribute({visible: false});
          cross1.setAttribute({visible: false});
          ok2.setAttribute({visible: false});
          cross2.setAttribute({visible: false});
          ok3.setAttribute({visible: false});
          cross3.setAttribute({visible: false});
          ok4.setAttribute({visible: false});
          cross4.setAttribute({visible: false});
          ok5.setAttribute({visible: false});
          cross5.setAttribute({visible: false});
          txt1ES.setText('Distance ');

          console.log('i == 0 MAL');
      }


      else if((i == 1 && op1ES.Value() >= 73.00 && op1ES.Value() <73.01)){

          ok0.setAttribute({visible: false});
          cross0.setAttribute({visible: false});
          ok1.setAttribute({visible: true});
          cross1.setAttribute({visible: false});
          ok2.setAttribute({visible: false});
          cross2.setAttribute({visible: false});
          ok3.setAttribute({visible: false});
          cross3.setAttribute({visible: false});
          ok4.setAttribute({visible: false});
          cross4.setAttribute({visible: false});
          ok5.setAttribute({visible: false});
          cross5.setAttribute({visible: false});
          txt2TM.setText(function(){return 'h = <br>' + op1ES.Value() + 'm'});

          console.log('i == 1 BIEN');
      }

      else if(i == 1){

          ok0.setAttribute({visible: false});
          cross0.setAttribute({visible: false});
          ok1.setAttribute({visible: false});
          cross1.setAttribute({visible: true});
          ok2.setAttribute({visible: false});
          cross2.setAttribute({visible: false});
          ok3.setAttribute({visible: false});
          cross3.setAttribute({visible: false});
          ok4.setAttribute({visible: false});
          cross4.setAttribute({visible: false});
          ok5.setAttribute({visible: false});
          cross5.setAttribute({visible: false});
          txt2TM.setText('h');

          console.log('i == 1 MAL');

      }

      else if((i == 2 && op1ES.Value() >= 444.31 && op1ES.Value() < 444.32)){

          ok0.setAttribute({visible: false});
          cross0.setAttribute({visible: false});
          ok1.setAttribute({visible: false});
          cross1.setAttribute({visible: false});
          ok2.setAttribute({visible: true});
          cross2.setAttribute({visible: false});
          ok3.setAttribute({visible: false});
          cross3.setAttribute({visible: false});
          ok4.setAttribute({visible: false});
          cross4.setAttribute({visible: false});
          ok5.setAttribute({visible: false});
          cross5.setAttribute({visible: false});
          txt1ET.setText(function(){return 'Distance = ' + op1ES.Value() + 'm'});


          console.log('i == 2 BIEN ');
      }


      else if(i == 2){

          ok0.setAttribute({visible: false});
          cross0.setAttribute({visible: false});
          ok1.setAttribute({visible: false});
          cross1.setAttribute({visible: false});
          ok2.setAttribute({visible: false});
          cross2.setAttribute({visible: true});
          ok3.setAttribute({visible: false});
          cross3.setAttribute({visible: false});
          ok4.setAttribute({visible: false});
          cross4.setAttribute({visible: false});
          ok5.setAttribute({visible: false});
          cross5.setAttribute({visible: false});
          txt1ET.setText('Distance ');

          console.log('i == 2 MAL');
      }

      else if(i == 3 && op1ES.Value() < 21.81 && op1ES.Value() >= 21.80){

          ok0.setAttribute({visible: false});
          cross0.setAttribute({visible: false});
          ok1.setAttribute({visible: false});
          cross1.setAttribute({visible: false});
          ok2.setAttribute({visible: false});
          cross2.setAttribute({visible: false});
          ok3.setAttribute({visible: true});
          cross3.setAttribute({visible: false});
          ok4.setAttribute({visible: false});
          cross4.setAttribute({visible: false});
          ok5.setAttribute({visible: false});
          cross5.setAttribute({visible: false});
          angleGI.setAttribute({name: function(){return '&theta;=' + op1ES.Value() + '°'}});

          console.log('i == 3 BIEN ');

      }


      else if(i == 3){

          ok0.setAttribute({visible: false});
          cross0.setAttribute({visible: false});
          ok1.setAttribute({visible: false});
          cross1.setAttribute({visible: false});
          ok2.setAttribute({visible: false});
          cross2.setAttribute({visible: false});
          ok3.setAttribute({visible: false});
          cross3.setAttribute({visible: true});
          ok4.setAttribute({visible: false});
          cross4.setAttribute({visible: false});
          ok5.setAttribute({visible: false});
          cross5.setAttribute({visible: false});
          angleGI.setAttribute({name: '&theta;(°)'});

          console.log('i == 3 MAL');
      }

      else if(i == 4 && op1ES.Value() >= 73.81 && op1ES.Value() < 73.82){

          ok0.setAttribute({visible: false});
          cross0.setAttribute({visible: false});
          ok1.setAttribute({visible: false});
          cross1.setAttribute({visible: false});
          ok2.setAttribute({visible: false});
          cross2.setAttribute({visible: false});
          ok3.setAttribute({visible: false});
          cross3.setAttribute({visible: false});
          ok4.setAttribute({visible: true});
          cross4.setAttribute({visible: false});
          ok5.setAttribute({visible: false});
          cross5.setAttribute({visible: false});
          angleSTAT.setAttribute({name: function(){return '&theta; =' + op1ES.Value() + '°'}});


          console.log('i == 4 BIEN ');
      }


      else if(i == 4){

          ok0.setAttribute({visible: false});
          cross0.setAttribute({visible: false});
          ok1.setAttribute({visible: false});
          cross1.setAttribute({visible: false});
          ok2.setAttribute({visible: false});
          cross2.setAttribute({visible: false});
          ok3.setAttribute({visible: false});
          cross3.setAttribute({visible: false});
          ok4.setAttribute({visible: false});
          cross4.setAttribute({visible: true});
          ok5.setAttribute({visible: false});
          cross5.setAttribute({visible: false});
          angleSTAT.setAttribute({name: '&theta;(°)'});

          console.log('i == 4 MAL');
      }

      else if((i == 5 && op1ES.Value() == 829.7) || (i == 5 && op1ES.Value() == 829.8) || (i == 5 && op1ES.Value() == 829.9)  ){

          ok0.setAttribute({visible: false});
          cross0.setAttribute({visible: false});
          ok1.setAttribute({visible: false});
          cross1.setAttribute({visible: false});
          ok2.setAttribute({visible: false});
          cross2.setAttribute({visible: false});
          ok3.setAttribute({visible: false});
          cross3.setAttribute({visible: false});
          ok4.setAttribute({visible: false});
          cross4.setAttribute({visible: false});
          ok5.setAttribute({visible: true});
          cross5.setAttribute({visible: false});
          txt2BURJ.setText(function(){return 'h = <br>' + op1ES.Value() + ' m'});

          console.log('i == 5 BIEN ');
      }

      else if(i == 5){

          ok0.setAttribute({visible: false});
          cross0.setAttribute({visible: false});
          ok1.setAttribute({visible: false});
          cross1.setAttribute({visible: false});
          ok2.setAttribute({visible: false});
          cross2.setAttribute({visible: false});
          ok3.setAttribute({visible: false});
          cross3.setAttribute({visible: false});
          ok4.setAttribute({visible: false});
          cross4.setAttribute({visible: false});
          ok5.setAttribute({visible: false});
          cross5.setAttribute({visible: true});
          txt2BURJ.setText('h');

          console.log('i == 5 MAL');
      }
  }

  tryMe.on('up', check);
  brd2.unsuspendUpdate();

}
}
export default Boxes;
